import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('jgz-background')
export class JgzBackground extends LitElement {
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="bg-layer" aria-hidden="true">
        <div class="bg-cloud bg-cloud-left"></div>
        <div class="bg-cloud bg-cloud-right"></div>

        <div class="bg-confetti bg-c-1"></div>
        <div class="bg-confetti bg-c-2"></div>
        <div class="bg-confetti bg-c-3"></div>
        <div class="bg-confetti bg-c-4"></div>
        <div class="bg-confetti bg-c-5"></div>
        <div class="bg-confetti bg-c-6"></div>
        <div class="bg-confetti bg-c-7"></div>
        <div class="bg-confetti bg-c-8"></div>
        <div class="bg-confetti bg-c-9"></div>
        <div class="bg-confetti bg-c-10"></div>

        <div class="bg-star bg-s-1"></div>
        <div class="bg-star bg-s-2"></div>
        <div class="bg-star bg-s-3"></div>
        <div class="bg-star bg-s-4"></div>
        <div class="bg-star bg-s-5"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jgz-background': JgzBackground;
  }
}
